import { SuccessSwal } from "../../app";
import { ajaxErrorAlert, ajaxPost } from "../utils";

$(function () {
  const body = $("body");

  if (body.hasClass("core-settings")) {
    $("#coreSettingsForm").on("submit", (e) => {
      e.preventDefault();
      const form = $(e.target);

      ajaxPost("", form.serializeArray(), form)
        .then(() => {
          SuccessSwal.fire({ timer: 1000 }).then(() => {
            window.location.reload();
          });
        })
        .catch((errors) => {
          ajaxErrorAlert(errors, form);
        });
    });
  }
});
